import { type Mark } from '#components/Form/RangeSlider/types.ts';
import { type Option } from '../types.ts';

export const areMarks = (list: Mark[] | Option[] | undefined = []): list is Mark[] =>
  list.every(entry => 'label' in entry && 'value' in entry);

export const areOptions = (list: unknown): list is Option[] =>
  Array.isArray(list) && list.every(entry => !!entry && typeof entry === 'object' && 'id' in entry && 'name' in entry);

export const isNumberList = (list: unknown): list is number[] =>
  Array.isArray(list) && list.every(entry => typeof entry === 'number');
